import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MainHubService } from "src/app/services/main-hub.service";

@Component({
  selector: "app-filters",
  templateUrl: "./filters.component.html",
  styleUrls: ["./filters.component.scss"],
})
export class FiltersComponent implements OnInit {
  constructor(public mainHubService: MainHubService) {}

  setFilters: FormGroup = new FormGroup({
    MaxQty: new FormControl("", Validators.required),
    MinRateOfReturnPerc: new FormControl("", Validators.required),
    MinOptionPrice: new FormControl("", Validators.required),
    UpDownStrikesDollarDiff: new FormControl("", Validators.required),
    UpDownStrikesCentDiff: new FormControl("", Validators.required),
  });

  ngOnInit(): void {
    setTimeout(() => {
      this.GetFields();
    }, 100);
  }

  async GetFields() {
    for (const field in this.setFilters.controls) {
      let value = await this.mainHubService.getFilter(field);
      this.setFilters.controls[field].setValue(value);
    }
  }

  async onSetFilters() {
    for (const field in this.setFilters.controls) {
      let value = this.setFilters.controls[field].value;
      if (value != "") {
        this.mainHubService.setFilter(field, value);
      }
    }
    this.GetFields();
  }
}
